export default __webpack_public_path__ + "static/media/icon1.99556d17.svg";